import type { FC } from 'react';

type EmptyTabStateProps = {
  heading: string;
  subtext?: string;
};

/** Empty / placeholder state for profile tab bodies (used by member feeds and coming-soon tabs). */
export const EmptyTabState: FC<EmptyTabStateProps> = ({ heading, subtext }) => (
  <div className="flex flex-col items-center justify-center gap-2 py-14 text-center">
    <p className="text-[15px] font-semibold leading-5 tracking-[-0.3px] text-black">{heading}</p>
    {subtext && <p className="text-[13px] leading-4 tracking-[-0.13px] text-black/50 max-w-[280px]">{subtext}</p>}
  </div>
);
